var _script, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclesBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1770,
    height: 1471,
    viewBox: "0 0 1770 1471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    id: "argent-x-extension",
    "data-extension-id": "{51e0c76c-7dbc-41ba-a45d-c579be84301b}"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1440.87 657.116C1622.29 657.116 1769.37 510.042 1769.37 328.616C1769.37 147.191 1622.29 0.116455 1440.87 0.116455C1259.44 0.116455 1112.37 147.191 1112.37 328.616C1112.37 510.042 1259.44 657.116 1440.87 657.116Z",
    fill: "url(#paint0_linear_921_122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M803.366 1069.12C803.366 847.65 623.608 668.116 401.866 668.116C180.124 668.116 0.365967 847.65 0.365967 1069.12C0.365967 1290.58 180.124 1470.12 401.866 1470.12C623.608 1470.12 803.366 1290.58 803.366 1069.12Z",
    fill: "url(#paint1_linear_921_122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_122",
    x1: 1457.63,
    y1: 698.458,
    x2: 1203.99,
    y2: -17.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#F2A498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F2A498",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_921_122",
    x1: 704.651,
    y1: 803.554,
    x2: 357.564,
    y2: 1034.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2A498",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#F2A498"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesBg);
export default __webpack_public_path__ + "static/media/circles-bg.d00d03748609cca23ad7546beeda9012.svg";
export { ForwardRef as ReactComponent };